import { Routes, Route } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";

import LoanCalculator from "./component/LoanCalculator";
import Home from "./component/Home";
import TermsConditions from "./component/TermsConditions";
import AboutUs from "./component/AboutUs";
import PrivacyPolicy from "./component/policies/PrivacyPolicy";
import FAQ from "./component/FAQ";
import ContactUs from "./component/ContactUs";
import InterestRatePolicy from "./component/policies/InterestRatePolicy";
import RiskManagementPolicy from "./component/policies/RiskManagementPolicy";
import KYCAmlPolicy from "./component/policies/KYCAmlPolicy";
import CancellationRefundPolicy from "./component/policies/CancellationRefundPolicy";
import FairPracticeCode from "./component/FairPracticeCode";
import CorporateGovernance from "./component/CorporateGovernance";
// import RepaymentNow from "./component/RepayNow";
import AccountDeletionPolicy from "./component/policies/AccountDeletionPolicy";
import WhyChooseUs from "./component/WhyChooseUs";
import HowItWorks from "./component/HowItWorks";
import FraudTicker from "./component/FraudTicker";

// Lazy so framer-motion (chatbot-only) stays out of the initial bundle.
const ChatBot = lazy(() => import("./component/ChatBot"));
// import Blog from "./component/Blog";
// import BlogDetails from "./component/BlogDetails";


const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/why-choose-us" element={<><Navbar /><WhyChooseUs /><Footer /></>} />
        <Route path="/how-it-works" element={<><Navbar /><HowItWorks /><Footer /></>} />
        <Route path="/loan-calculator" element={<><Navbar /><LoanCalculator standalone /><Footer /></>} />
        <Route path="/about" element={<><Navbar /><AboutUs /><Footer /></>} />
        <Route path="/faq" element={<><Navbar /><FAQ /><Footer /></>} />
        <Route path="/contact" element={<><Navbar /><ContactUs /><Footer /></>} />
        <Route path="/repay" element={<ExternalRedirect to={`${import.meta.env.VITE_WEBSITE_LINK}/repay-now`} />} />
        <Route path="/terms-condition" element={<><Navbar /><TermsConditions /><Footer /></>} />
        <Route path="/privacy-policy" element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
         <Route path="/interest-rate-policy" element={<><Navbar /><InterestRatePolicy /><Footer /></>} />
        <Route path="/risk-management-policy" element={<><Navbar /><RiskManagementPolicy /><Footer /></>} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicy />} />
        <Route path="/fair-practice-code" element={<><Navbar /><FairPracticeCode /><Footer /></>} />
        <Route path="/corporate-governance" element={<><Navbar /><CorporateGovernance /><Footer /></>} />
        <Route path="/kyc-aml-policy" element={<KYCAmlPolicy />} />
        <Route path="/account-delete-policy" element={<AccountDeletionPolicy />} />
        
      </Routes>
      <Suspense fallback={null}>
        <ChatBot />
      </Suspense>
      <FraudTicker />
    </>
  );
}

export default App;
